import {useContext} from 'react';
import {GuestlistDataContext} from '~/ViewInvitation/components/Guestlist/context/GuestlistDataContext';

export const useGuestlistDataContext = () => {
  const context = useContext(GuestlistDataContext);

  if (!context) {
    throw new Error('useGuestlistDataContext must be used within a GuestlistDataContextProvider');
  }

  return context;
};
